export default {
	// 页面固定字符
	_page: {
		// 对话框
		msgbox: {
			ok: '确定',
			cancel: '取消'
		},

		// 日期选择器
		datePicker: {
			shortcut: {
				today: '今天',
				yesterday: '昨日',
				week: '7天内',
				month: '上个月',
				quarter: '3个月内'
			},
			label: {
				startTime: '开始时间',
				endTime: '结束时间',
				year: '年',
				month: '月',
				weekDay: ['一', '二', '三', '四', '五', '六', '日']
			},
			button: {ok: '确定'}
		},

		// 页面头部
		top: {
			logout: '退出登录'
		},

		// 登录
		login: {
			caption: '用户登录',
			register: ['还没有账户？点击', '注册'],
			email: {
				text: '邮箱',
				placeholder: '请输入邮箱'
			},
			password: {
				text: '密码',
				placeholder: '请输入密码'
			},
			button: {
				login: '登录',
				forgetPassword: '忘记密码？'
			}
		},

		// 注册
		register: {
			caption: '注册',
			login: ['已有账户？点击', '登录'],
			role: {
				text: '角色',
				placeholder: '我是：',
				items: {
					cp: '广告主',
					pub: '流量主'
				}
			},
			username: {text: '联系人姓名', placeholder: '联系人姓名'},
			email: {text: '邮箱', placeholder: '邮箱'},
			company: {text: '公司名称', placeholder: '公司名称'},
			website: {text: '网站', placeholder: '网站'},
			password: {text: '密码', placeholder: '密码'},
			repassword: {text: '确认密码', placeholder: '确认密码'},
			passwordNotice: '使用字母或者数字，最少6个字符',
			howtoknow: {placeholder: '你是怎么知道我们的？'},
			agree: ['我同意', '《条款与隐私政策》'],
			button: {
				register: '立即注册'
			},
			message: {registerSuccess: '注册成功'}
		},

		// 忘记密码
		forgetPassword: {
			caption: '找回密码',
			register: ['还没有账户？点击', '注册'],
			email: {text: '邮箱', placeholder: '请输入电子邮件'},
			password: {text: '密码', placeholder: '请输入新密码'},
			repassword: {text: '确认密码', placeholder: '确认密码'},
			button: {
				find: '提交',
				login: '返回登录'
			},
			message: {
				sendMailSuccess: '邮件发送成功，请查收邮件。',
				changePasswordSuccess: '密码修改成功。'
			}
		},

		common: {
			account: {
				caption: '账户信息',
				input: {
					username: {
						text: '联系人姓名', placeholder: '请输入联系人姓名'
					},
					email: {
						text: '邮箱', placeholder: '注册时的邮箱不允许修改。'
					},
					company: {
						text: '公司名称', placeholder: '请输入公司名称'
					},
					website: {
						text: '网站', placeholder: '请输入网站'
					},
					mobile: {
						text: '联系电话', placeholder: '请输入您的联系电话'
					}
				},
				button: {
					save: '保存'
				},
				message: {saveSuccess: '保存成功！'}
			},

			password: {
				caption: '',
				input: {
					theold: {
						text: '当前密码', placeholder: '请输入当前密码'
					},
					thenew: {
						text: '新密码', placeholder: '请输入新密码'
					},
					renew: {
						text: '确认密码', placeholder: '请再次输入新密码'
					}
				},
				button: {
					save: '保存'
				},
				message: {saveSuccess: '密码修改成功！'}
			}
		}, // common end

		// 广告主
		cp: {
			// 导航
			nav: {
				campaign: '广告管理',
				account: '账户管理',
				finance: '财务报表',
				accountInfo: '账户信息',
				password: '密码修改'
			},
			// 广告
			campaign: {
				welcome: ['欢迎来到ADYes', '开始创建您的第一条广告。', '新建广告'],
				list: {
					bar: {
						createCampaign: '新建广告',
						search: '搜索',
						download: '下载报表',
						namePlaceholder: '请输入要搜索的广告名称',
						status: '状态'
					},
					title: {
						campaign_name: '广告名称',
						app_name: '应用名称',
						os: '操作系统',
						show_number: '展示数',
						click_number: '点击数',
						cr: '点击率',
						install_number: '安装数',
						ir: '安装率',
						bid: '出价',
						spend: '花费',
						create_time: '创建日期',
						approval_status: '审核状态',
						delivery_status: '投放状态',
						day_budget: '日预算',
						operating: '操作'
					},
					operate: {
						startup: '启动', edit: '编辑', stop: '停用'
					}
				}, // list end
				dialog: {
					firstStartup: '计划首次启用需要审核，通过后可自动进入投放状态，确定启动吗？'
				} // dialog end
			}, // campaign end

			campaignEdit: {
				basic: {
					caption: ['基本信息', '输入您的广告名称，并填写您的应用信息'],
					input: {
						name: {
							text: '广告名称',
							placeholder: '请输入您的广告名称'
						},
						os: {text: '操作系统'},
						app_name: {
							text: '应用名称',
							placeholder: '请输入您的应用名称'
						},
						package_name: {
							text: '应用包名/应用ID',
							placeholder: '请输入您的应用包名/应用ID'
						},
						app_category: {
							text: '应用类别',
							placeholder: '选择一个应用类别'
						}
					} // input end
				}, // basic end
				tracking: {
					caption: ['跟踪方法', '选择您要使用的跟踪平台，以便跟踪安装。'],
					input: {
						method: {
							text: '追踪方法'
						}
					}
				},
				targeting: {
					caption: ['定向选择', '选择您的推广定向条件'],
					input: {
						countries: {
							text: '选择国家', placeholder: '选择您要推广的地区'
						},
						device_type: {
							text: '选择设备类型', select: {all: '所有设备类型', specific: '具体设备类型'}
						},
						os_ver: {
							text: '选择操作系统版本', select: {all: '所有版本', specific: '具体版本'}
						},
						net_speed: {
							text: '连接速度', select: {all: '所有连接速度', specific: '仅WIFI'}
						},
						google_facebook: {
							text: '是否需要Facebook或Google投放'
						}
					}
				},
				url: {
					caption: ['跟踪网址', '输入您的AppsFlyer点击和展示跟踪网址。'],
					input: {
						click_url: {
							text: '点击链接'
						}
					}
				},
				budgets: {
					caption: ['推广预算', '选择您的出价类型，并定义预算价格。'],
					input: {
						bid_type: {
							text: '出价类型'
						},
						bid: {
							text: '出价', placeholder: '请输入您的价格（美金）'
						},
						day_budget: {
							text: '日预算',
							placeholder: '输入您的预算金额（美金）',
							notice: '温馨提示：提高预算当日生效，降低预算次日生效'
						}
					}
				},
				save: {
					newCaption: ['广告创建完成', '恭喜您完成广告创建!'],
					modifyCaption: ['广告修改完成'],
					button: {
						ok: '完成并保存'
					}
				},
				button: {
					lastStep: '上一步', nextStep: '下一步'
				},
				message: {
					saveSuccess: '广告计划保存成功！'
				}
			}, // createCampaign end

			ads: {
				list: {
					bar: {
						createAds: '新建广告创意',
						search: '搜索',
						namePlaceholder: '请输入要搜索的广告序列或广告创意名称',
						status: '状态'
					},
					title: {
						name: '广告创意名称',
						app_name: '应用名称',
						type: '广告形式',
						show_number: '展示数',
						click_number: '点击数',
						cr: '点击率',
						install_number: '安装数',
						ir: '安装率',
						bid: '出价',
						spend: '花费',
						create_time: '创建日期',
						status: '投放状态',
						operating: '操作'
					},
					operate: {
						startup: '启动', edit: '编辑', stop: '停用', view: '查看'
					}
				},
				message: {
					startup: '广告创意启用后将不能再进行修改，确定启动吗？'
				}
			}, // ads end

			adsEdit: {
				caption: ['新建广告创意', '输入您的广告创意名称，并填写素材用信息'],
				input: {
					name: {text: '广告创意名称', placeholder: '请输入您的广告创意名称'},
					type: {
						text: '广告创意类型'
					},
					size: {text: '素材尺寸', placeholder: '请选择一个尺寸'},
					ads: {text: '素材信息'},
					adsIcon: {text: '素材应用图标'}
				}, // input end
				button: {
					add: '添加素材',
					addIcon: '添加应用图标',
					save: '保存',
					cancel: '返回'
				},
				message: {
					info: '请在广告图片中添加“免费下载”"Play Now" 等点击按钮，以提升产品的下载量。',
					fileRequire: '素材尺寸规范[ {pic_size} ]，支持上传[ {file_type} ]类型文件，大小不能超过[ {file_size} ]。',
					saveSuccess: '保存成功',
					tip: 'ADyes不接受任何含有暴力、色情、毒品等违法内容或可能引起用户不适的广告素材。上传前请您检查您的素材是否合规。对于违规素材，ADyes有权随时停止投放。',
					previewCaption: '预览广告样式',
					deleteAttachConfirm: '是否确定删除素材？'
				}
			}, // adsEdit end

			finance: {
				caption: '账户余额',
				list: {
					title: { date: '日期', spend: '支出', recharge: '存入' }
				}
			} // finance end
		}, // cp end

		pub: {
			nav: {publish: '流量管理', account: '账户信息', password: '密码修改'},
			publish: {
				message: '当前没有收入。联系ADyes获取安装ADyes SDK的指导说明，当SDK初始化之后，您的APP会在此出现。'
			}
		}
	},

	// 错误信息
	_error: {
		systemError: '服务器出错，请重试！',
		warning: '错误：',
		noInput: '没有填写！',
		noData: '数据为空！',
		noLogin: '您没有登录，或登录信息已过期，请重新登录!',
		paramError: '参数错误！',
		inputError: '输入内容有误！',
		saveDataFailure: '数据保存失败！',

		passwordError: '密码输入错误！',
		accountOrPasswordError: '账户或密码错误！',

		emailInvalid: '邮件地址无效！',
		emailValidFailed: '邮件验证失败，请重新发送邮件！',
		oldPasswordError: '旧密码错误！',
		newPasswordError: '新密码输入错误！',

		imageError: '图片异常，请重新上传！',
		fileSizeError: '附件大小不合法！',
		fileWHError: '附件尺寸不合法！',
		fileExtensionError: '附件类型不合法！',
		removeError: '删除失败！',
		adsNoAttach: '广告素材文件未上传',

		registerDataExists: '邮箱已注册！',
		attachPostTypeError: '附件类型与选择的广告创意类型不一致',

		moneyNotEnough: '账户余额不足',
		budgetShortage: '预算不足，请提高预算后再次开启'
	},

	// 其他非页面固定字符
	'List total': '合计',

	'Ads image': '图片广告',
	'Ads video': '视频广告',
	'Ads native ads': '原生广告',

	'Status paused': '暂停',
	'Status active': '投放中',

	'Approval pending': '审核中',
	'Approval passed': '已审核',
	'Approval did not pass': '审核未通过',

	'Option choose one': '请选择',

	'How did you hear about us ?': '您是怎么知道我们的？',
	'Friend': '朋友',
	'Blog/Forum': '博客/论坛',
	'Advertising': '广告',
	'Other': '其他',
	'Yes': '是',
	'No': '否',

	'Click or Drag and Drop files here upload': '点击此处，或者拖动文件到此处进行上传',

	'Africa': '非洲',
	'Asia': '亚洲',
	'Eastern Europe': '东欧洲',
	'Latin America and the Caribbean': '拉丁美洲和加勒比',
	'North America': '北美',
	'Oceania (AU, NZ, Pacific Islands)': '大洋洲',
	'Western Europe': '西欧',
	'Algeria (DZ)': '阿尔及利亚（DZ）',
	'Angola (AO)': '安哥拉（AO）',
	'Benin (BJ)': '贝宁（BJ）',
	'Botswana (BW)': '博茨瓦纳(BW)',
	'Burkina Faso (BF)': '布基纳法索（BF）',
	'Burundi (BI)': '布隆迪（BI）',
	'Cameroon (CM)': '喀麦隆（CM）',
	'Cape Verde (CV)': '佛得角（CV）',
	'Central African Republic (CF)': '中非共和国（CF）',
	'Chad (TD)': '乍得（TD）',
	'Comoros (KM)': '科摩罗（KM）',
	'Congo (CG)': '刚果（CG）',
	'Congo, the Democratic Republic of the (CD)': '刚果民主共和国（CD）',
	'Cote D\' Ivoire (CI)': '科特迪瓦（CI）',
	'Djibouti (DJ)': '吉布提（DJ）',
	'Egypt (EG)': '埃及（EG）',
	'Equatorial Guinea (GQ)': '赤道几内亚(GQ)',
	'Eritrea (ER)': '厄立特里亚(ER)',
	'Ethiopia (ET)': '埃塞俄比亚（ET）',
	'Gabon (GA)': '加蓬（GA）',
	'Gambia (GM)': '冈比亚（GM）',
	'Ghana (GH)': '加纳（GH）',
	'Guinea (GN)': '几内亚（GN）',
	'Guinea-Bissau (GW)': '几内亚比绍（GW）',
	'Kenya (KE)': '肯尼亚（KE）',
	'Lesotho (LS)': '莱索托（LS）',
	'Liberia (LR)': '利比里亚（LR）',
	'Libyan Arab Jamahiriya (LY)': '阿拉伯利比亚民众国（LY）',
	'Madagascar (MG)': '马达加斯加(MG)',
	'Malawi (MW)': '马拉维（MW）',
	'Mali (ML)': '马里（ML）',
	'Mauritania (MR)': '毛里塔尼亚(MR)',
	'Mauritius (MU)': '毛里求斯（MU）',
	'Mayotte (YT)': '马约特（YT）',
	'Morocco (MA)': '摩洛哥（MA）',
	'Mozambique (MZ)': '莫桑比克（MZ）',
	'Namibia (NA)': '纳米比亚（NA）',
	'Niger (NE)': '尼日尔(NE)',
	'Nigeria (NG)': '尼日利亚（NG）',
	'Reunion (RE)': '团聚（RE）',
	'Rwanda (RW)': '卢旺达（RW）',
	'Saint Helena, Ascension and Tristan da Cunha (SH)': '圣赫勒拿，阿森松和特里斯坦达库尼亚（SH）',
	'Sao Tome and Principe (ST)': '圣多美和普林西比（ST）',
	'Senegal (SN)': '塞内加尔（SN）',
	'Seychelles (SC)': '塞舌尔（SC）',
	'Sierra Leone (SL)': '塞拉利昂（SL）',
	'Somalia (SO)': '索马里（SO）',
	'South Africa (ZA)': '南非（ZA）',
	'South Sudan (SS)': '南苏丹（SS）',
	'Sudan (SD)': '苏丹（SD）',
	'Swaziland (SZ)': '斯威士兰（SZ）',
	'Tanzania, United Republic of (TZ)': '坦桑尼亚联合共和国（TZ）',
	'Togo (TG)': '多哥（TG）',
	'Tunisia (TN)': '突尼斯（TN）',
	'Uganda (UG)': '乌干达(UG)',
	'Western Sahara (EH)': '西撒哈拉（EH）',
	'Zambia (ZM)': '赞比亚（ZM）',
	'Zimbabwe (ZW)': '津巴布韦（ZW）',
	'Afghanistan (AF)': '阿富汗(AF)',
	'Armenia (AM)': '亚美尼亚(AM)',
	'Azerbaijan (AZ)': '阿塞拜疆（AZ）',
	'Bahrain (BH)': '巴林（BH）',
	'Bangladesh (BD)': '孟加拉国(BD)',
	'Bhutan (BT)': '不丹（BT）',
	'Brunei Darussalam (BN)': '文莱达鲁萨兰国(BN)',
	'Cambodia (KH)': '柬埔寨（KH）',
	'China (CN)': '中国（CN）',
	'Cyprus (CY)': '塞浦路斯（CY）',
	'Georgia (GE)': '格鲁吉亚（GE）',
	'Hong Kong (HK)': '香港（HK）',
	'India (IN)': '印度（IN）',
	'Indonesia (ID)': '印度尼西亚(ID)',
	'Iran (IR)': '伊朗（IR）',
	'Iraq (IQ)': '伊拉克（IQ）',
	'Israel (IL)': '以色列（IL）',
	'Japan (JP)': '日本（JP）',
	'Jordan (JO)': '约旦（JO）',
	'Kazakhstan (KZ)': '哈萨克斯坦(KZ)',
	'Korea, Democratic People\'s Republic of (KP)': '韩国，朝鲜民主主义人民共和国（KP）',
	'Kuwait (KW)': '科威特（KW）',
	'Kyrgyzstan (KG)': '吉尔吉斯斯坦(KG)',
	'Lao People\'s Democractic Republic (LA)': '老挝人民民主共和国(LA)',
	'Lebanon (LB)': '黎巴嫩（LB）',
	'Macao (MO)': '澳门（MO）',
	'Malaysia (MY)': '马来西亚（MY）',
	'Maldives (MV)': '马尔代夫（MV）',
	'Mongolia (MN)': '蒙古（MN）',
	'Myanmar (MM)': '缅甸(MM)',
	'Nepal (NP)': '尼泊尔(NP)',
	'Oman (OM)': '阿曼（OM）',
	'Pakistan (PK)': '巴基斯坦(PK)',
	'Palestinian Territory, Occupied (PS)': '巴勒斯坦领土，占领区（PS）',
	'Philippines (PH)': '菲律宾（PH）',
	'Qatar (QA)': '卡塔尔（QA）',
	'Saudi Arabia (SA)': '沙特阿拉伯（SA）',
	'Singapore (SG)': '新加坡（SG）',
	'Sri Lanka (LK)': '斯里兰卡（LK）',
	'Syria (SY)': '叙利亚（SY）',
	'Taiwan (TW)': '台湾（TW）',
	'Tajikistan (TJ)': '塔吉克斯坦（TJ）',
	'Thailand (TH)': '泰国（TH）',
	'Timor-Leste (TL)': '东帝汶(TL)',
	'Turkey (TR)': '土耳其（TR）',
	'Turkmenistan (TM)': '土库曼斯坦(TM)',
	'United Arab Emirates (AE)': '阿拉伯联合酋长国（AE）',
	'Uzbekistan (UZ)': '乌兹别克斯坦(UZ)',
	'Viet Nam (VN)': '越南（VN）',
	'Yemen (YE)': '也门（YE）',
	'Korea, Republic of (KR)': '韩国（KR）',
	'Albania (AL)': '阿尔巴尼亚（AL）',
	'Belarus (BY)': '白俄罗斯（BY）',
	'Bosnia and herzegovina (BA)': '波斯尼亚和黑塞哥维那(BA)',
	'Bulgaria (BG)': '保加利亚（BG）',
	'Croatia (HR)': '克罗地亚（HR）',
	'Czech Republic (CZ)': '捷克共和国（CZ）',
	'Estonia (EE)': '爱沙尼亚（EE）',
	'Holy See (Vatican City State) (VA)': '教廷（梵蒂冈城）（VA）',
	'Hungary (HU)': '匈牙利（HU）',
	'Latvia (LV)': '拉脱维亚（LV）',
	'Lithuania (LT)': '立陶宛（LT）',
	'Macedonia, the Former Yugoslav Republic of (MK)': '马其顿前南斯拉夫的（MK）',
	'Moldova, Republic of (MD)': '摩尔多瓦共和国（MD）',
	'Montenegro (ME)': '黑山（ME）',
	'Poland (PL)': '波兰（PL）',
	'Romania (RO)': '罗马尼亚（RO）',
	'Russian Federation (RU)': '俄罗斯联邦（RU）',
	'Serbia (RS)': '塞尔维亚（RS）',
	'Slovakia (SK)': '斯洛伐克（SK）',
	'Slovenia (SI)': '斯洛文尼亚（SI）',
	'Svalbard and Jan Mayen (SJ)': '斯瓦尔巴德和扬・梅嫩（SJ）',
	'Ukraine (UA)': '乌克兰（UA）',
	'Aland Islands (AX)': '爱尔兰群岛（AX）',
	'Anguilla (AI)': '安圭拉（AI）',
	'Antigua and Barbuda (AG)': '安提瓜和巴布达（AG）',
	'Argentina (AR)': '阿根廷（AR）',
	'Aruba (AW)': '阿鲁巴（AW）',
	'Bahamas (BS)': '巴哈马（BS）',
	'Barbados (BB)': '巴巴多斯（BB）',
	'Belize (BZ)': '伯利兹（BZ）',
	'Bolivia (BO)': '玻利维亚（BO）',
	'Bonaire, Sint Eustatius and Saba (BQ)': '博内尔岛，Sint Eustatius和Saba（BQ）',
	'Brazil (BR)': '巴西（BR）',
	'Cayman Islands (KY)': '开曼群岛（KY）',
	'Chile (CL)': '智利（CL）',
	'Colombia (CO)': '哥伦比亚（CO）',
	'Costa Rica (CR)': '哥斯达黎加(CR)',
	'Cuba (CU)': '古巴（CU）',
	'Curacao (CW)': '库拉索（CW）',
	'Dominica (DM)': '多米尼克（DM）',
	'Dominican Republic (DO)': '多米尼加共和国（DO）',
	'Ecuador (EC)': '厄瓜多尔（EC）',
	'El Salvador (SV)': '萨尔瓦多（SV）',
	'Falkland Islands (Malvinas) (FK)': '福克兰群岛（马尔维纳斯）（FK）',
	'French Guiana (GF)': '法属圭亚那（GF）',
	'Grenada (GD)': '格林纳达（GD）',
	'Guadeloupe (GP)': '瓜德罗普（GP）',
	'Guatemala (GT)': '危地马拉（GT）',
	'Guyana (GY)': '圭亚那（GY）',
	'Haiti (HT)': '海地（HT）',
	'Honduras (HN)': '洪都拉斯（HN）',
	'Jamaica (JM)': '牙买加（JM）',
	'Martinique (MQ)': '马提尼克（MQ）',
	'Mexico (MX)': '墨西哥（MX）',
	'Montserrat (MS)': '蒙特塞拉特（MS）',
	'Nicaragua (NI)': '尼加拉瓜（NI）',
	'Panama (PA)': '巴拿马（PA）',
	'Paraguay (PY)': '巴拉圭（PY）',
	'Peru (PE)': '秘鲁（PE）',
	'Puerto Rico (PR)': '波多黎各（PR）',
	'Saint Barthélemy (BL)': '圣巴特雷米（BL）',
	'Saint Kitts and Nevis (KN)': '圣基茨和尼维斯（KN）',
	'Saint Lucia (LC)': '圣卢西亚（LC）',
	'Saint Martin (French part) (MF)': '圣马丁（法语部分）（MF）',
	'Saint Vincent and the Grenadines (VC)': '圣文森特和格林纳丁斯（VC）',
	'Sint Maarten (Dutch part) (SX)': '圣马丁（荷兰语部分）（SX）',
	'Suriname (SR)': '苏里南（SR）',
	'Trinidad and Tobago (TT)': '特立尼达和多巴哥（TT）',
	'Turks and Caicos Islands (TC)': '特克斯和凯科斯群岛（TC）',
	'Uruguay (UY)': '乌拉圭（UY）',
	'Venezuela (VE)': '委内瑞拉（VE）',
	'Virgin Islands (VI)': '维尔京群岛（VI）',
	'Virgin Islands, British (VG)': '维京群岛，英国（VG）',
	'Bermuda (BM)': '百慕大（BM）',
	'Canada (CA)': '加拿大（CA）',
	'Greenland (GL)': '格陵兰（GL）',
	'Saint Pierre and Miquelon (PM)': '圣皮埃尔和密克隆（PM）',
	'United States (US)': '美国（US）',
	'American Samoa (AS)': '美属萨摩亚（AS）',
	'Australia (AU)': '澳大利亚（AU）',
	'Cook Islands (CK)': '库克群岛（CK）',
	'Fiji (FJ)': '斐济（FJ）',
	'French Polynesia (PF)': '法属波利尼西亚（PF）',
	'Guam (GU)': '关岛（GU）',
	'Kiribati (KI)': '基里巴斯（KI）',
	'Marshall Islands (MH)': '马绍尔群岛（MH）',
	'Micronesia, Federated States of (FM)': '密克罗尼西亚联邦（FM）',
	'Nauru (NR)': '瑙鲁（NR）',
	'New Caledonia (NC)': '新喀里多尼亚（NC）',
	'New Zealand (NZ)': '新西兰（NZ）',
	'Niue (NU)': '纽埃（NU）',
	'Norfolk Island (NF)': '诺福克岛（NF）',
	'Northern Mariana Islands (MP)': '北马里亚纳群岛（MP）',
	'Palau (PW)': '帕劳（PW）',
	'Papua New Guinea (PG)': '巴布亚新几内亚（PG）',
	'Pitcairn (PN)': '皮特凯恩（PN）',
	'Samoa (WS)': '萨摩亚（WS）',
	'Solomon Islands (SB)': '所罗门群岛（SB）',
	'Tokelau (TK)': '托克劳（TK）',
	'Tonga (TO)': '汤加（TO）',
	'Tuvalu (TV)': '图瓦卢（TV）',
	'Vanuatu (VU)': '瓦努阿图（VU）',
	'Wallis and Futuna (WF)': '瓦利斯和富图纳（WF）',
	'Andorra (AD)': '安道尔（AD）',
	'Austria (AT)': '奥地利（AT）',
	'Belgium (BE)': '比利时（BE）',
	'Denmark (DK)': '丹麦（DK）',
	'Faroe Islands (FO)': '法罗群岛(FO)',
	'Finland (FI)': '芬兰（FI）',
	'France (FR)': '法国（FR）',
	'Germany (DE)': '德国（DE）',
	'Gibraltar (GI)': '直布罗陀（GI）',
	'Greece (GR)': '希腊（GR）',
	'Guernsey (GG)': '根西（GG）',
	'Iceland (IS)': '冰岛（IS）',
	'Ireland (IE)': '爱尔兰（IE）',
	'Isle of Man (IM)': '马恩岛（IM）',
	'Italy (IT)': '意大利（IT）',
	'Jersey (JE)': '泽西（JE）',
	'Liechtenstein (LI)': '列支敦士登(LI)',
	'Luxembourg (LU)': '卢森堡（LU）',
	'Malta (MT)': '马耳他（MT）',
	'Monaco (MC)': '摩纳哥（MC）',
	'Netherlands (NL)': '荷兰（NL）',
	'Norway (NO)': '挪威（NO）',
	'Portugal (PT)': '葡萄牙（PT）',
	'San Marino (SM)': '圣马力诺（SM）',
	'Spain (ES)': '西班牙（ES）',
	'Sweden (SE)': '瑞典（SE）',
	'Switzerland (CH)': '瑞士（CH）',
	'United Kingdom (GB)': '英国（GB）',

	'Books & Reference': '图书与参考',
	'Comics': '漫画',
	'Dating': '约会',
	'Education': '教育',
	'Entertainment(non-gaming)': '娱乐（非游戏）',
	'Finance': '金融',
	'Game': '游戏',
	'Health & Fitness': '健康与健身',
	'Jobs': '工作',
	'Lifestyle': '生活方式',
	'Media & Video': '媒体与视频',
	'Music & Audio': '音乐与音频',
	'News & Magazines': '新闻杂志',
	'Personalization': '个性化',
	'Photography': '摄影',
	'Productivity': '生产率',
	'Shopping': '购物',
	'Social': '社会',
	'Sports(non-gaming)': '体育（非游戏）',
	'Tools': '工具',
	'Transportation': '运输',
	'Travel & Local': '旅游与地区',
	'Weather': '天气',

	'iPod': '苹果音乐播放器',
	'iPhone': '苹果手机',
	'Tablet': '平板电脑',
	'Phone': '手机',

	'iOS': 'iOS版本',
	'Android': 'Android版本'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js